import { type InputHTMLAttributes, useId } from 'react';
import { cn } from '@vendedor/ui';

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  error?: string;
}

/** Campo de formulario mínimo (mismos tokens que apps/web-admin/components/text-field.tsx). */
export function TextField({ label, error, className, ...input }: TextFieldProps) {
  const id = useId();
  const describedBy = `${id}-desc`;
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={id} className="text-sm font-bold text-fg-2">
        {label}
      </label>
      <div
        className={cn(
          'flex min-h-field items-center overflow-hidden rounded-field border bg-surface',
          'transition-shadow duration-(--motion-fast) ease-standard focus-within:shadow-focus',
          error ? 'border-danger' : 'border-border-strong',
        )}
      >
        <input
          id={id}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? describedBy : undefined}
          className="min-h-field w-full min-w-0 flex-1 border-0 bg-transparent px-3.5 font-body text-lg text-fg outline-none placeholder:text-meta"
          {...input}
        />
      </div>
      {error ? (
        <p id={describedBy} className="m-0 text-sm font-medium text-danger-ink" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
